import { Component } from '@angular/core';
import { NavController, ModalController, ToastController, LoadingController, NavParams } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';

import { Tracking, Dokumen  } from '@providers/asset/index';

@Component({
  selector: 'page-finish-opname',
  templateUrl: 'page.html'
})
export class FinishOpnamePage {

  form = {
    note:'',
    witness:'',
    dokumen_id:'',
    generated_name:'',
    status:1,
    location_id:0
  };
  location:any={};
  ListLocationTracking:any=[];
  img_url='';
  tracking:any={};

  constructor(
    public trackingApi: Tracking,
    public dokApi: Dokumen,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController, 
    public camera: Camera,
    navParams: NavParams
  ) {
    if(navParams.get('location')!=undefined){
      this.location = navParams.get('location');
      this.form.location_id = this.location.id;
    }
    this.img_url = this.dokApi.file_url;
    this.tracking = this.trackingApi.data;
  }
  
  ionViewDidEnter() {
    this.getList();
  }

  takePicture(){
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth : 1024,
      sourceType:1
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  fromLibrary(){
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth : 1024,
      sourceType:0
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }

  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokApi.post(params).subscribe((resp:any) => {
      this.form.dokumen_id=resp.data.id;
      this.form.generated_name=resp.data.generated_name;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  simpan(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = this.form;
    this.trackingApi.post_location(params).subscribe((resp:any) => {
      loading.dismiss();
      this.getList();
      //this.navCtrl.pop();
    }, (err) => {
      loading.dismiss();
    });
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { tracking_id: this.tracking.id, location_id:this.location.id };
    let get = this.trackingApi.getTrackingLocation(params);
    get.subscribe((resp:any) => {
      if(resp.data.length>0){
        this.ListLocationTracking = resp.data;
      }else{
        
      }
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/finish_opname/page.ts